import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components';

import { ErrorBoundary } from '@salud-front/shared';
import { IndexComponent } from './components/lay.ingresarCitaMedica';

import './styles/index.less';

ReactDOM.createRoot(document.getElementById('Ingreso-Agendar-Cita-Medica')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <FluentProvider theme={teamsLightTheme}>
        <IndexComponent />
      </FluentProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
